define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpPrStatusDomain = void 0;
    class FWpPrStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FWpPrStatusDomain.Due, value: "Due" },
                    { key: FWpPrStatusDomain.Submitted, value: "Submitted" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FWpPrStatusDomain.Due] = 0;
                this.KeyIndex[FWpPrStatusDomain.Submitted] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Due"] = 0;
                this.ValueIndex["Submitted"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FWpPrStatusDomain = FWpPrStatusDomain;
    Object.defineProperty(FWpPrStatusDomain, "Due", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FWpPrStatusDomain, "Submitted", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FWpPrStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
